// extracted by mini-css-extract-plugin
export default {"root":"CountryFlag_root__Jpnq2","image":"CountryFlag_image__OnPkd"};